import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { ProjectActivity } from 'projects/app-misc/src/app/modules/project-misc/data/project/activity/project-activity';
import * as moment from 'moment';

@Component({
    selector: 'app-event-tip',
    templateUrl: './event-tip.component.html',
    styleUrls: ['./event-tip.component.scss']
})
export class EventTipComponent implements OnInit, OnChanges {
    @Input()
    activityInHint: ProjectActivity;

    hours: string;

    constructor() { }

    ngOnInit() {
    }

    ngOnChanges() {
        const now = moment()
        const b = moment(now).add(this.activityInHint.duration, 'seconds')
        this.hours = b.diff(now, 'hours') + 'h'
    }

}
